import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { getQueryParam } from "../managers/common/CommonUtil";
import RootInterceptorService, {
	RootInterceptorObservable,
} from "../services/RootInterceptorService";

const RootInterceptor = (props) => {
	const history = useHistory();
	const [code] = useState(getQueryParam(props.location, "code"));

	useEffect(() => {
		if (!code) {
			RootInterceptorObservable.sendMessage({ evaluated: true });
			return;
		}

		if (code) {
			const payload = {
				code: code
			};

			RootInterceptorService.workdayLogin(payload).then(
				(response) => {
					if (props.location?.pathname) {
						history.replace({
							pathname: props.location.pathname,
							search: '',
						});
					}
					RootInterceptorObservable.sendMessage({ evaluated: true });
				},
				(error) => {
					RootInterceptorObservable.sendMessage({
						evaluated: true,
						error: error,
					});
				}
			);
		}
	}, [code]);

	return <Fragment></Fragment>;
};

export default RootInterceptor;
